module.exports = __webpack_public_path__ + "static/przemek-b25819123018ef8612c36896c47eeb05.webp";